/**
 * Error ID constants for tracking and monitoring — attached to log/Sentry
 * events so recurrences correlate across releases. Values are historical
 * and must stay stable; the SaaS-era catalog this file once held lives in
 * git history.
 */

export const ERROR_IDS = {
  NOTES_DOCUMENT_MALFORMED: 'NOT-006',   // Tiptap JSON failed strict schema validation
  NOTES_SANITIZE_URL_FAILED: 'CHAT-008', // Disallowed URL scheme stripped during content sanitization
} as const;
